<template>
  <div>
    <div style="margin:10px 0">
        <span v-if="label" style="margin-right:15px">渠道：</span>
        <el-radio-group v-model="currentValue"  @input="inputChange" placeholder="请选择">
            <el-radio label="">全部</el-radio>
            <el-radio v-for="item in list" :label="item" :key="item">{{item}}</el-radio>
        </el-radio-group>
    </div>
  </div>
</template>

<script>
import {get_channel} from "../../request/api.js"
export default {
  data() {
    return {
      list:[
      ],
      currentValue: '',
    };
  },
  props: {
    props_value: {
      type: String,
      default: '',
    },
    label: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    inputChange(val) {
      this.$emit('handle_select', val);
    },
    selectInput(val){
      this.currentValue = val
    },
    freshData(){
        get_channel().then((res)=>{
            if(res.status==0){
                this.list=res.detail
                this.currentValue = this.props_value || '';
            }
        })
        this.currentValue = this.props_value || '';
    }
  },
  created() {
    this.freshData()
  },
};
</script>

<style></style>
